export const REGULARIZATION_STAGES = {
  NOT_APPLICABLE: 'notApplicable',
  APPLICABLE: 'applicable',
  PENDING: 'pending',
  PRESENT: 'present',
  ABSENT: 'absent',
  HALF_DAY:'halfDay'

}
